import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  Router,
  RouteReuseStrategy,
  withComponentInputBinding,
  withDisabledInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions
} from '@angular/router';

import { DropdownModule, SidebarModule } from '@coreui/angular-pro';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TokenInterceptor } from './auth/token.interceptor';
import { TenantInterceptor } from './auth/tenant.interceptor';
import { KeycloakService } from './auth/keycloak.service';
import { APP_INITIALIZER } from '@angular/core';
import { provideI18n } from './i18n';
import { ReportCurrencyInterceptor, ReportCurrencyRouteReuseStrategy } from './reporting/report-currency';

export function initializeKeycloak(keycloak: KeycloakService, router: Router) {
  return async () => {
    // Fully initialize Keycloak (which may include parsing the OAuth
    // callback and restoring the original deep link via history.replaceState)
    // BEFORE the router reads window.location for its initial navigation.
    await keycloak.init();
    router.initialNavigation();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withDisabledInitialNavigation(),
      withViewTransitions(),
      withHashLocation()
    ),
    importProvidersFrom(SidebarModule, DropdownModule),
    IconSetService,
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakService, Router],
      multi: true,
    },
    provideAnimationsAsync(),
    { provide: RouteReuseStrategy, useClass: ReportCurrencyRouteReuseStrategy },
    provideHttpClient(withInterceptors([ReportCurrencyInterceptor, TokenInterceptor, TenantInterceptor])),
    provideI18n()
  ]
};
